// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.c7iOCYMKCLfgzNXVjBo5 {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Set the container height to 100% of the viewport height */
  background: #005293;
  padding-left: 0 !important;
  padding-right: 0 !important;
  box-shadow: #193551 inset -4px 0px;
}

ul li{
  list-style: none;
}

.L9bg_uXChXH2xeqi1dCa{
  text-align: left;
}


.L9bg_uXChXH2xeqi1dCa a {
  color: #fecb00;
  text-decoration: none;
}

ul {
  list-style: none;
  padding-left: 0;
  margin-left: 0;
  padding: 10px;
}

ul li {
  margin-bottom: 10px;
  font-weight: bold;
}

li a {
  text-decoration: none;
  color: white;
  
}`, "",{"version":3,"sources":["webpack://./src/NavigationMenu.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,4DAA4D;EAC3E,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;;AAEd","sourcesContent":["\n.sidebarContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Set the container height to 100% of the viewport height */\n  background: #005293;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  box-shadow: #193551 inset -4px 0px;\n}\n\nul li{\n  list-style: none;\n}\n\n.logoText{\n  text-align: left;\n}\n\n\n.logoText a {\n  color: #fecb00;\n  text-decoration: none;\n}\n\nul {\n  list-style: none;\n  padding-left: 0;\n  margin-left: 0;\n  padding: 10px;\n}\n\nul li {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\nli a {\n  text-decoration: none;\n  color: white;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarContainer": `c7iOCYMKCLfgzNXVjBo5`,
	"logoText": `L9bg_uXChXH2xeqi1dCa`
};
export default ___CSS_LOADER_EXPORT___;
